import React from 'react';
import { Button, ButtonClean, List, Subsection, Tooltip, useCopyToClipboard, } from '@fourthwall/components';
import { DuplicateIcon, TickIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import * as S from './Webhooks.styled';
import { WebhookListItem } from './components/WebhookListItem/WebhookListItem';
export const WebhooksView = ({ webhooksListProps, clientSecret, onWebhookCreate, }) => {
    const { isCopied, copyToClipboard } = useCopyToClipboard();
    return (React.createElement(Subsection, { title: "Webhooks", id: "webhooks" },
        React.createElement(S.Description, null,
            "You can subscribe to events for your products and orders by creating webhooks that will push JSON notifications to a given URL.",
            ' ',
            React.createElement(ButtonClean, { label: "Learn more", href: routing.external.docs.self, target: "_blank" })),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: "Create webhook", size: "small", disabled: !onWebhookCreate, onClick: onWebhookCreate })),
        React.createElement(List, { renderItem: (webhookItem) => React.createElement(WebhookListItem, { ...webhookItem }), ...webhooksListProps }),
        clientSecret && (React.createElement(S.ClientSecretContainer, null,
            "Webhooks will be signed with secret token so you can verify their integrity:",
            React.createElement("br", null),
            React.createElement(S.ClientSecretContainerValue, null,
                clientSecret,
                isCopied ? (React.createElement(Tooltip, { reference: React.createElement(TickIcon, { height: 12 }) }, "Copied!")) : (React.createElement(Tooltip, { reference: React.createElement(ButtonClean, { label: "", icon: DuplicateIcon, onClick: () => copyToClipboard(clientSecret) }) }, "Copy")))))));
};
